import { render, staticRenderFns } from "./BioPlatform.vue?vue&type=template&id=5649a5b1&scoped=true"
import script from "./BioPlatform.vue?vue&type=script&lang=js"
export * from "./BioPlatform.vue?vue&type=script&lang=js"
import style0 from "./BioPlatform.vue?vue&type=style&index=0&id=5649a5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649a5b1",
  null
  
)

export default component.exports